<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">User Management</h2>
    </div>
    <form class="needs-validation pt-1 my-2" @submit.prevent="getUsers">
      <div class="form-group row justify-content-between m-0">
        <div class="mx-3 my-1">
          <label class="col-form-label mr-3">Tenants</label>

          <dropdownlist
            class="my-2"
            ref="tenantDropdown"
            :data-items="tenants"
            :text-field="'name'"
            :data-item-key="'id'"
            :default-value="tenants[0]"
            @change="onSelectTenant"
          >
          </dropdownlist>
          <button
            type="submit"
            value="Search"
            class="k-button k-secondary btn mx-4 py-1"
          >
            <i class="fa fa-search" aria-hidden="true"></i> Search
          </button>
        </div>

        <div class="my-auto mx-auto mx-sm-2">
          <button
            title="Add new"
            class="k-button k-secondary"
            @click="insert"
            type="button"
          >
            <i class="fa fa-plus mr-2" aria-hidden="true"></i>

            Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="users">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :sortable="true"
        :resizable="true"
        :filterable="true"
        :filter="filter"
        :groupable="false"
        :group="group"
        :sort="sort"
        :skip="skip"
        :data-items="gridData"
        :columns="columns"
        :take="take"
        @datastatechange="dataStateChange"
        @expandchange="expandChange"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>
        <grid-toolbar class="text-left"> </grid-toolbar>
        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="userInEdit"
        :data-source-array="dataSourceArray"
        :dialog-title="dialogTitle"
        :tenants="tenants"
        :data-item="userInEdit"
        :selected-identity="selectedIdentity"
        :selected-tenant="selectedTenant"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import DialogContainer from "./DialogContainer";
import { process } from "@progress/kendo-data-query";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";
import { orderBy } from "@progress/kendo-data-query";

export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  },
  props: {
    identity: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      base_url: undefined,
      sort: [{ field: "userName", dir: "asc" }],
      filter: {
        logic: "and",
        filters: [],
      },
      gridData: [],
      skip: 0,
      take: 10,
      group: [],
      users: [],
      userInEdit: undefined,
      tenants: [],
      selectedIdentity: undefined,
      selectedTenant: undefined,
      tempIdentity: this.identity,
      tempTenant: undefined,
      columns: [
        {
          field: "userName",
          title: "User Name",
          width: "250px",
        },
        { field: "email", title: "Email", width: "250px" },

        { field: "phoneNumber", title: "Phone Number", width: "250px" },

        {
          field: "roles",
          title: "Roles",
          cell: this.listRoles,
          filterable: false,
        },

        { field: "tenantName", title: "Tenant Name", filterable: false },

        { cell: "myTemplate", width: "150px", filterable: false },
      ],
    };
  },
  computed: {
    dialogTitle() {
      return `${this.userInEdit.id === undefined ? "Add" : "Edit"} user`;
    },
  },
  mounted: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    if (this.tempIdentity != null) {
      this.getTenants();
    }
  },
  watch: {
    identity: function () {
      this.tempIdentity = this.identity;
      this.tempTenant = undefined;
      this.$refs.tenantDropdown.currentValue = this.tenants[0];
      this.getTenants();
    },
  },
  methods: {
    dataStateChange: function (event) {
      this.createAppState(event.data);
      console.log(event);
    },

    expandChange: function (event) {
      Vue.set(event.dataItem, event.target.$props.expandField, event.value);
    },
    createAppState: function (dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.filter = dataState.filter;
      this.sort = dataState.sort;
      console.log(dataState);
      this.getData();
    },
    getData: function () {
      console.log("aaa", this.filter);
      this.gridData = process(this.users, {
        take: this.take,
        skip: this.skip,
        group: this.group,
        sort: this.sort,
        filter: this.filter,
      });
    },
    async getUsers() {
      this.selectedIdentity = this.tempIdentity;
      this.selectedTenant = this.tempTenant;
      try {
        const response = await axios.get(
          this.base_url +
            "User/GetUsers/" +
            this.selectedIdentity.id +
            "/" +
            this.selectedTenant.id
        );
        this.users = response.data.result;
        this.getData();
        this.getRoles();
      } catch (err) {
        console.log(err);
      }
    },
    async getTenants() {
      if (this.tempIdentity == null) return;
      else {
        try {
          const client_id = oidcSettings.client_id;
          const response = await axios.get(
            this.base_url + "Tenant/GetTenants/" + this.tempIdentity.id
          );
          this.tenants = response.data.result;
          this.tenants.unshift({ id: " ", name: "No Tenant" });
          this.tempTenant = this.tenants[0];
          this.getUsers();
        } catch (err) {
          console.log(err);
        }
      }
    },
    onSelectTenant(event) {
      console.log("change", event.target.value);
      this.tempTenant = event.target.value;
    },
    listRoles(h, tdElement, props, listeners) {
      var roles = props.dataItem.roles.map((role) => role.roleName);
      roles = roles.join(",");
      return h("td", [roles]);
    },
    edit(dataItem) {
      this.userInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);
        const client_id = oidcSettings.client_id;

        const response = await axios.delete(
          this.base_url +
            "User/DeleteUser/" +
            dataItem.id +
            "/" +
            this.selectedIdentity.id +
            "/" +
            this.selectedTenant.id
        );
        this.users = this.users.filter((p) => p.id !== dataItem.id);
        this.getData();
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    async save() {
      const dataItem = this.userInEdit;
      const users = this.users.slice();
      const isNewUser = dataItem.id === undefined;
      const client_id = oidcSettings.client_id;
      let data = {
        Id: dataItem.id,
        UserName: dataItem.userName,
        Email: dataItem.email,
        PhoneNumber: dataItem.phoneNumber,
        PasswordHash: dataItem.isExternalUser ? "" : dataItem.password,
        Roles: dataItem.roles,
        TenantID: dataItem.tenantID,
        TwoFactorEnabled: dataItem.twoFactorEnabled,
        IsActive: dataItem.isActive,
        IsExternalUser: dataItem.isExternalUser,
        SmsChannelKey: dataItem.smsChannelKey,
        EmailChannelKey: dataItem.emailChannelKey,
      };
      if (isNewUser) {
        try {
          const response = await axios
            .post(
              this.base_url +
                "User/AddUser/" +
                this.selectedIdentity.id +
                "/" +
                client_id +
                "/" +
                dataItem.tenantID,
              data
            )
            .then((response) => {
              var newUser = response.data.result;
              console.log(newUser.tenantID, "ti");
              console.log(this.selectedTenant.id, "ti2");
              if (
                newUser.tenantID == this.selectedTenant.id ||
                (!newUser.tenantID && !this.selectedTenant.id.trim())
              ) {
                users.unshift(newUser);
              }
            });
          // this.getUsers();
          //this.$router.push("/home");
        } catch (err) {
          console.log("Ooops!" + err);
        }
      } else {
        try {
          //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);
          const response = await axios.put(
            this.base_url +
              "User/UpdateUser/" +
              this.selectedIdentity.id +
              "/" +
              this.selectedTenant.id,
            data
          );
          const index = users.findIndex((p) => p.id === dataItem.id);
          users.splice(index, 1, dataItem);
        } catch (err) {
          console.log("Ooops!" + err);
        }
      }
      this.users = users;
      this.getData();
      this.userInEdit = undefined;
    },
    cancel() {
      this.userInEdit = undefined;
    },
    insert() {
      this.userInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
    newUser(source) {
      const id =
        this.users.reduce((acc, current) => Math.max(acc, current.id || 0), 0) +
        1;
      const newUser = {
        id: id,
        userName: "",
        email: "",
        phoneNumber: "",
        password: "",
        roles: [],
      };

      return Object.assign(newUser, source);
    },
    getRoles: async function () {
      //const response = await axios.get("https://localhost:5001/api/IdentityPool/GetIdentityPools");
      const client_id = oidcSettings.client_id;

      const response = await axios.get(
        this.base_url + "Role/GetRoles/" + this.selectedIdentity.id
      );
      this.dataSourceArray = response.data.result;
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}

.needs-validation {
  background: white;
}
</style>